"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const LanguageSwitcher_vue_1 = require("@/client/components/LanguageSwitcher.vue");
const PreferencesIcon_vue_1 = require("@/client/components/PreferencesIcon.vue");
const raw_settings = require("@/genfiles/settings.json");
const constants = require("@/common/constants");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'start-screen',
    components: {
        LanguageSwitcher: LanguageSwitcher_vue_1.default,
        PreferencesIcon: PreferencesIcon_vue_1.default,
    },
    computed: {
        raw_settings() {
            return raw_settings;
        },
        DISCORD_INVITE() {
            return constants.DISCORD_INVITE;
        },
    },
});
